import { DEFAULT_DISCOUNTS } from '@/data/templates/quotes/defaultQuoteTemplates';
import type { Discount } from '@/pages/sidebar/SettingsPage/types';

const STORAGE_KEY = 'drahft_invoice_discounts';

export const loadInvoiceDiscounts = (): Discount[] => {
  if (typeof window === 'undefined') {
    return DEFAULT_DISCOUNTS;
  }

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_DISCOUNTS;

    const parsed = JSON.parse(raw) as Discount[];
    if (!Array.isArray(parsed)) return DEFAULT_DISCOUNTS;

    return parsed.filter(
      item =>
        item &&
        typeof item.id === 'string' &&
        typeof item.name === 'string' &&
        typeof item.amount === 'number' &&
        (item.type === '$' || item.type === '%')
    );
  } catch {
    return DEFAULT_DISCOUNTS;
  }
};

export const saveInvoiceDiscounts = (discounts: Discount[]) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(discounts));
};
